<template>
  <div class="video-processing">
    <div class="video-processing__icon">
      <ProcessningIcon class="video-processing__img" />
    </div>
    <div class="video-processing__title">
      The video will be available in a few seconds once we complete the processing.
    </div>
  </div>
</template>

<script>
import ProcessningIcon from './images/processing-icon.vue.svg';

export default {
  name: 'VideoProcessing',
  components: {
    ProcessningIcon,
  },
  props: {
    muxVideoId: {
      type: Number,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      statusTimeoutId: null,
    };
  },
  mounted() {
    this.getProcessingStatus();
  },
  beforeDestroy() {
    clearTimeout(this.statusTimeoutId);
  },
  methods: {
    async getProcessingStatus() {
      const data = await this.$api.$get(`/mux_videos/${this.muxVideoId}.json`);

      if (data.playback_id) {
        this.$emit('ready', data.playback_id);
      } else {
        this.statusTimeoutId = setTimeout(() => {
          this.getProcessingStatus();
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video-processing {
  height: 280px;
  background: var(--gray-03);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 80px;
  flex-grow: 1;

  &__icon {
    width: 72px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--gray-20);
    border-radius: 50%;
    margin-bottom: 22px;
  }

  &__img {
    width: 24px;
    height: 24px;
    color: var(--gray-50);
  }

  &__title {
    @include body;

    text-align: center;
    color: var(--gray-50);
  }
}
</style>
